// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutDeliveryServices_container__30d7x"};